export default __webpack_public_path__ + "static/media/zetta.1c9b834f.svg";